const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/genres.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/genres")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: () => {
    return {
      meta: [{
        title: i18n.t("genres.meta.title"),
        description: i18n.t("genres.meta.description")
      }]
    };
  },
  loader: async ({
    context
  }) => {
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["genres-list"],
      queryFn: () => httpClient.get<GenreResponse[]>("/offers/genres").catch(() => [])
    });
    return {
      dehydratedState: dehydrate(queryClient)
    };
  }
});